<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('studentEnrollment.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('studentEnrollment.pageTitle'),
          href: '/student-enrollments'
        },
        {
          text: $t('add_new'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6">
            <class-operation v-model="model" />
            <div class="validate" v-if="errors.has('class_id')">
              {{ errors.first('class_id') }}
            </div>
          </div>
          <div class="col-md-6">
            <student-list v-model="model" />
            <div class="validate" v-if="errors.has('student_id_list')">
              {{ errors.first('student_id_list') }}
            </div>
            <div class="row">
              <div class="col-md-12 text-right mt-2">
                <ts-button @click="$router.push({ name: 'student-enrollment' })" class="btn btn-default mr-2">{{
                  $t('cancel') }}</ts-button>
                <ts-button @click="saveAddNew" outline color="primary" :waiting="waiting_save_new">{{ $t('save_add_new')
                  }}</ts-button>
                <ts-button class="btn btn-primary ml-2" :waiting="waiting_save" @click.prevent="store">{{ $t('save')
                  }}</ts-button>
              </div>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import { debounce } from 'lodash'
import ClassOperation from './components/class-operation'
import StudentList from './components/student-list'

export default {
  name: 'studentEnrollmentCreate',
  components: {
    ClassOperation,
    StudentList
  },
  data() {
    return {
      model: {
        class_id: '',
        student_id_list: [],
        acps_id: [],
        level_id: [],
        promotion: [],
        batch: null
      },
      student_search_value: '',
      student_search: false,
      waiting_save: false,
      waiting_save_new: false,
      errors: new Errors()
    }
  },
  created() { },
  computed: {},
  methods: {
    async store() {
      this.waiting_save = true
      this.$store
        .dispatch('studentEnrollment/store', this.model)
        .then(response => {
          this.waiting_save = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'student-enrollment' })
        })
        .catch(error => {
          this.waiting_save = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    async saveAddNew() {
      this.waiting_save_new = true
      this.$store
        .dispatch('studentEnrollment/store', this.model)
        .then(response => {
          this.waiting_save_new = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.waiting_save_new = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearInput() {
      ; (this.model.class_id = ''), (this.model.student_id_list = [])
    }
  }
}
</script>

<style lang="css" scoped>
#container-class-operation {
  height: 70vh;
}

#enroll {
  height: 70vh;
}

#student-table-container {
  height: 40vh;
  overflow-y: scroll;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px;
  /* Remove scrollbar space */
  background: transparent;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}

::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}

#class-operation-table>thead>tr>th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}

#student-table>thead>tr>th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}

#class-operation-table>tbody>tr>td {
  cursor: pointer;
}

#student-table>tbody>tr>td {
  cursor: pointer;
}

.loading {
  background-color: #ffffff;
  background-image: url('http://loadinggif.com/images/image-selection/3.gif');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
</style>
